import { useState, useMemo, useEffect, useRef } from 'react';
import '../../../assets/css/StudentDashboard.css'
import SearchBar from '../../../Component/SearchBar.js';
import { SuccessfulPopup } from '../../../Component/Modals/SuccessfulPopup.js';
import Table from '../../../Component/Table.js';
import { useNavigate, useNavigation } from 'react-router-dom';
import { Deletedata, getBlob, getData, patchData, postBlob, Postdata, Postdataform, PostFileData, updateData } from '../../../API/GlobalApi.js';

import { handlePaginate } from '../../../Utils/handlePagination.js';


import ConfirmationModal from '../../../Component/Modals/ConfirmationModal.js';
import { formatDateDDMMYYYY, formatDateDDMMYYYYHHMMSS, formatDateDDMMYYYYHHMMSS_UTC } from '../../../Utils/data&dateTime.js';
import SpinnerLoader from '../../../Utils/Spinner.js';
import SearchingBar from '../../../Utils/Searching.js';
import Notifier from '../../../Utils/notify.js';
import FeeNoticeCourseWise from '../../../Component/Modals/FeeNoticeCourseWisePrint.js';
import FeeNoticeStudentsWise from '../../../Component/Modals/FeeNoticeStudentWisePrint.js';
import AdvanceTable from '../../../Utils/AdvanceTables.js';
import OtpModal from '../../../Component/Modals/DiscountOtpInput.js';
import { generateResendScheduledFeePDF } from '../../../Utils/generatePdfForTemplateSent.js';

import { v4 as uuidv4 } from "uuid";
import { WaitFeeApprovalsModal } from '../../../Component/Modals/WaitApprovalForFeeTemplate.js';
import TableSkeleton from '../../../Utils/TableSkeleton.js';
import { formatCourseListWithRoman } from '../../../Utils/ConvertRoman.js';
import { AddPenalityInFeeScheduledFee } from '../../../Component/Modals/AddPenalityInFeeScheduled.js';
import Select from 'react-select'
import TableLoaderOverlay from '../../../Utils/tableFadingLoader.js';
import { useTableFade } from '../../../Utils/tableFadeHooks.js';
import { reactSelectStyles } from '../../../Utils/selectBoxStyle.js';

export const ManageFeeScheduleAndDue = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isSearchLoading, setSearchLoading] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [showWaittingModal, setShowWaitingModal] = useState(false)
    const [selectedScheduledFee, setSelectedScheduledFee] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [scheduledFeeData, setScheduledFeeData] = useState([])
    const [modalMode, setModalMode] = useState('create');
    const [filterScheduledFee, setFilterScheduledFee] = useState([])
    const [filterQueryString, setFilterQueryString] = useState({});
    const navigate = useNavigate();
    const pageSize = 10;
    const pageCounts = Math.ceil(totalCount / pageSize);
    const [filterLoading, setFilterLoading] = useState(false);

    const [showPenalityCreateModal, setShowPenalityCreateModal] = useState(false);

    const handleOpenPenalityGiveInFeeDue = () => {
        setShowPenalityCreateModal(true)
    }


    const getFeeScheduledFee = async (page = 0) => {
        const pageNumber = page + 1;
        // Convert object to query string
        const queryString = filterQueryString && Object.keys(filterQueryString).length > 0
            ? new URLSearchParams(filterQueryString).toString()
            : "";

        const url = queryString
            ? `finance/course-fee-schedule/?${queryString}&page=${pageNumber}`
            : `finance/course-fee-schedule/?page=${pageNumber}`;
        if (isInitialLoad) setIsLoading(true);
        else setSearchLoading(true);
        try {
            const response = await getData(url);

            const data = response?.results || [];
            const count = response?.count || 0;

            setScheduledFeeData(data);
            setFilterScheduledFee(data)
            setTotalCount(count);

            if (data.length > 0) {
                // const firstPOId = pos[0].id;
                // await getPOById(firstPOId);
            }
        } catch (error) {
            Notifier.error(error)
            setScheduledFeeData([]);
            // setTotalCount(0);
        } finally {
            if (isInitialLoad) {
                setIsLoading(false);
                setIsInitialLoad(false);
            } else {
                setSearchLoading(false);
            }
            setFilterLoading(false);
        }
    };

    const { skipSpinnerRef, tableLoading, triggerTableLoading, stopTableLoading } = useTableFade();

    const currentPageRef = useRef(currentPage);

    // useEffect(() => {
    //     currentPageRef.current = currentPage;
    //     getFeeScheduledFee(currentPage);
    // }, [currentPage, filterQueryString]);



    useEffect(() => {
        currentPageRef.current = currentPage;
        getFeeScheduledFee(currentPage)
            .finally(() => stopTableLoading()); // hide fade after completion
    }, [currentPage, filterQueryString]);



    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
        triggerTableLoading();
        // getFeeScheduledFee(selected).finally(() => stopTableLoading());
    };




    const [courseOptions, setCourseOptions] = useState([]);
    const [semesterOptions, setSemesterOptions] = useState([]);

    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedSemester, setSelectedSemester] = useState(null);


    const getCourses = async () => {
        try {
            const response = await getData("academics/get-all-courses-unpaginated/");

            if (response?.data?.length) {
                // save full response for semester mapping
                setCourseOptions(response.data.map(item => ({
                    ...item,                 // keep academic_groups
                    label: item.name,
                    value: item.id,
                })));
            }
        } catch (error) {
            Notifier.error("Course getting errors");
            setCourseOptions([]);
        }
    };




    useEffect(() => {
        getCourses();
    }, []);



    const handleCourseChange = (course) => {
        setSelectedCourse(course);

        if (!course) {
            // User cleared course → reset everything
            setSemesterOptions([]);
            setSelectedSemester(null);

            setFilterQueryString({}); // clear all filters

            setCurrentPage(0);
            skipSpinnerRef.current = true;
            setFilterLoading(true);

            getFeeScheduledFee(0);
            return;
        }

        // Extract semesters
        const sems = course.academic_groups?.map(g => ({
            label: g.name,
            value: g.academic_group_id,
        })) || [];

        setSemesterOptions(sems);
        setSelectedSemester(null);

        // ⬅️ Add course_id to query
        setFilterQueryString({
            specialization_id: course?.value || ""
        });

        setCurrentPage(0);
        skipSpinnerRef.current = true;
        setFilterLoading(true);
    };


    const handleSemesterChange = (sem) => {
        setSelectedSemester(sem);

        setFilterQueryString(prev => ({
            ...prev,
            academic_group_id: sem?.value || ""  // semester id
        }));

        setCurrentPage(0);
        skipSpinnerRef.current = true;
        setFilterLoading(true);
    };

    const handleRowClick = async (id, row) => {
        try {
            const selectedOrg = row?.original;
            console.log("row?.origina", row?.original)
            setSelectedScheduledFee(selectedOrg)

        } catch (error) {

        }
    };

    const sourceData = useMemo(() => {
        return filterQueryString ? filterScheduledFee : scheduledFeeData;
    }, [scheduledFeeData, filterScheduledFee, filterQueryString]);

    const batchUniqueIds = uuidv4();
    const formattedData = useMemo(() => {
        if (!Array.isArray(sourceData) || sourceData.length === 0) return [];

        return sourceData.map((batch) => {
            // Flatten students
            const students_list = (batch.fee_schedules || []).map((s) => ({
                id: `${s.fee_head_id}_${batch.academic_group_id}_${s.unique_id}`,
                student_id: s.student_id,
                student_name: s.student_name || "-",
                student_registration: s.student_registration || "-",
                fee_head_id: s.fee_head_id,
                fee_head_name: s.fee_head_name,
                amount: s.amount,
                amount_paid: s.amount_paid,
                payment_type: s.payment_type,
                due_date: s.due_date,
                penalty_per_day: s.penalty_per_day,
                max_penalty: s.max_penalty,
                remarks: s.remarks,
                created_at: s.created_at,
                created_by: s.created_by,
                document_number: batch.document_number,
            }));

            // Unique fee head names
            const fee_head_names = Array.from(
                new Set((batch.fee_schedules || []).map(f => f.fee_head_name))
            ).join(", ");

            // Total students and amount
            const total_students = students_list.length;
            const total_amount_scheduled = students_list.reduce(
                (sum, s) => sum + (s.amount || 0),
                0
            );

            // Determine course_mode display
            const course_mode = batch.course_mode === false ? "Individual wise" : "Course wise";

            // Batch-level unique ID
            // const batchUniqueId = batch.fee_schedules?.[0]
            //     ? `${batch.fee_schedules[0].fee_head_id}_${batch.academic_group_id}_${batch.fee_schedules[0].unique_id}`
            //     : `${batch.academic_group_id}_${batchUniqueIds}`;
            console.log("batch===", batch)

            const batchUniqueId = `${batch.unique_id}_${batch.created_at}`;

            return {
                id: batchUniqueId,
                unique_id: batch?.unique_id,
                document_number: batch.document_number,
                full_course_name: batch.full_course_name,
                academic_year: batch.academic_year,
                fee_head_names,
                total_students,
                total_amount_scheduled,
                due_date: batch.fee_schedules?.[0]?.due_date || null,
                created_at: batch.fee_schedules?.[0]?.created_at || null,
                created_by: batch.fee_schedules?.[0]?.created_by || "-",
                course_mode,
                verified: batch.verified || false,
                students_list,
            };
        });
    }, [sourceData]);





    const searchInputRef = useRef(null);
    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, []);



    const [helpdeskperson, setHelpDeskPerson] = useState([]);

    const gethelpdeskPerson = async () => {
        try {
            const url = "finance/course-fee-plans/authorized-employees/?type=schedule";
            const response = await getData(url);

            if (response?.authorized_employees?.length) {
                setHelpDeskPerson(response.authorized_employees);
            }
        } catch (error) {
            console.error("Error fetching authorized employees:", error);
        }
    };
    useEffect(() => {
        gethelpdeskPerson()
    }, [])


    const [otpModalOpen, setOtpModalOpen] = useState(false);
    const [otpModalKey, setOtpModalKey] = useState(0);

    const handelSendOtp = (row) => {
        setSelectedScheduledFee(row?.original)
        setOtpModalOpen(true);
    };


    const handleCancelOtp = () => {
        setOtpModalOpen(false);
        setOtpModalKey(prev => prev + 1);
        setStudentResponse('')
    };


    const [studentResponse, setStudentResponse] = useState('')

    const handlesResendOtpToAssignedPerson = async (employeeIds = []) => {
        if (!selectedScheduledFee) return;

        try {
            // setIsSubmittingCalc(true);


            // 1️⃣ Generate PDF from selected schedule
            // const uniqueFileName = uuidv4().replace(/-/g, "").slice(0, 20);
            const pdfBlob = await generateResendScheduledFeePDF(selectedScheduledFee);

            // 2️⃣ Upload PDF to S3
            // const fileUrl = await uploadToS3(pdfBlob, selectedScheduledFee.id);
            // if (!fileUrl) throw new Error("File upload failed — S3 URL not received.");

            // 3️⃣ Construct approval URL
            const approvalUrl = `${process.env.REACT_APP_WINDOW_BASEURL2}fee/schedule-aprrovals-course-wise/${selectedScheduledFee.unique_id}`;

            // 4️⃣ Prepare payload
            const payload = {
                unique_id: selectedScheduledFee.unique_id,
                employee_ids: employeeIds.join(','),
                // document_url: fileUrl,
                // document_uuid: uniqueFileName,
                approval_url: approvalUrl
            };

            // 4️⃣ Create FormData object
            const formData = new FormData();

            // Attach the generated PDF file
            formData.append("document_url", pdfBlob, `${selectedScheduledFee.unique_id}.pdf`);

            // Append all payload fields
            Object.entries(payload).forEach(([key, value]) => {
                if (typeof value === "object" && value !== null) {
                    formData.append(key, JSON.stringify(value));
                } else {
                    formData.append(key, value);
                }
            });




            // 5️⃣ Call API
            const response = await Postdataform('finance/resend-ledger-schedule-otp/', formData);

            if (!response?.error) {
                setStudentResponse({ otp: response.otps, unique_id: response?.unique_id });
                Notifier.success("Approval message sent successfully to the assigned person!");
                setOtpModalOpen(false)
                // ✅ Show waiting modal on success
                setShowWaitingModal(true);
            } else {
                Notifier.error(response.message || "Failed to resend OTP.");
            }
        } catch (error) {
            console.error("Resend OTP failed:", error);
            const errorMessage = error?.message || "Something went wrong. Please try again.";
            Notifier.error(errorMessage);
        } finally {
            // setIsSubmittingCalc(false);
        }
    };

    const [showReminderModal, setShowReminderModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSendReminder = (row) => {

        setSelectedRow(row.original);
        setShowReminderModal(true);
    };

    const confirmSendReminder = async () => {
        try {
            setIsSubmitting(true);
            const payload = {
                unique_id: selectedRow.unique_id,
                payment_link: `${process.env.REACT_APP_WINDOW_BASEURL2}student/fee-payment`
            };
            const response = await Postdata(`finance/scheduled-fee-payment/`, payload);
            // ✅ handle success based on actual response
            if (response?.students && response.students.length > 0) {
                Notifier.success(`Reminder sent successfully to ${response.students.length} students!`);
                setShowReminderModal(false);
            } else {
                Notifier.error('Failed to send reminder — no students returned!');
            }
        } catch (error) {
            console.error(error);
            Notifier.error('Failed to send reminder!');
        } finally {
            setIsSubmitting(false);
        }
    };

    const [showNoticeModal, setShowNoticeModal] = useState(false);
    const handleSendNotice = (row) => {
        setSelectedRow(row.original);
        setShowNoticeModal(true)

    }
    // ✅ When user confirms sending the notice
    const confirmSendNotice = async () => {
        try {
            setIsSubmitting(true);

            const payload = {
                unique_id: selectedRow.unique_id,
                payment_link: `${process.env.REACT_APP_WINDOW_BASEURL2}student/fee-payment`
            };

            const response = await Postdata("finance/scheduled-fee-due-notice/", payload);

            if (response?.success) {
                Notifier.success("Due notice sent successfully to students!");
            } else {
                const errorMessage = Object.entries(response)
                    .map(([key, val]) => `${key}: ${Array.isArray(val) ? val.join(", ") : val}`)
                    .join("\n");

                Notifier.error(errorMessage || "Failed to send due notice!");
            }


        } catch (error) {
            console.error("Error sending notice:", error);
            Notifier.error("An error occurred while sending the notice.");
        } finally {
            setIsSubmitting(false);
            setShowNoticeModal(false);
        }
    };
    const columns = useMemo(
        () => [

            {
                Header: "Course | Semester ",
                accessor: 'full_course_name',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: 'pointer' }}
                        // onClick={() => {
                        //   navigate(`/studentDashboard/StudentFullProfile/${row.original.id}`);
                        // }}
                        onClick={() => handleRowClick(row.original.id, row)}                     >
                        <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0, whiteSpace: 'pre-line', }}>
                            {row.original.full_course_name}
                        </p>

                    </div>
                ),
            },
            {
                Header: "Academic Year",
                accessor: 'academic_year',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: 'pointer' }}
                    >
                        <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
                            {row.original.academic_year}
                        </p>

                    </div>
                ),
            },

            {
                Header: () => <p style={{ textAlign: 'start' }}>Fee Heads</p>,
                accessor: 'fee_head_names',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div className="no-text-cursor">

                        <p style={{ textAlign: 'start', color: '#222F3E', margin: 0, whiteSpace: 'pre-line' }}>{row.original.fee_head_names}</p>
                    </div>
                )
            },
            {
                Header: () => <p style={{ textAlign: 'start' }}>Total Students</p>,
                accessor: 'total_students',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div className="no-text-cursor" >
                        <p style={{ textAlign: 'start', color: '#222F3E', margin: 0 }}>{row.original.total_students}</p>
                    </div>
                )
            },



            {
                Header: () => <p style={{ textAlign: 'start' }}>Due Date</p>,
                accessor: 'due_date',
                disableSortBy: true,
                Cell: ({ row }) => {
                    const rawDate = row.original.due_date;
                    return (
                        <div className="no-text-cursor">
                            <p style={{ textAlign: 'start', color: '#222F3E', margin: 0 }}>
                                {formatDateDDMMYYYY(rawDate)}
                            </p>
                        </div>
                    );
                }
            },

            {
                Header: () => <p style={{ textAlign: 'start', }}>Creation Date</p>,
                accessor: 'created_at',
                disableSortBy: true,
                Cell: ({ row }) => {
                    const rawDate = row.original.created_at;
                    return (
                        <div className="no-text-cursor">
                            <p style={{ textAlign: 'start', color: '#222F3E', margin: 0 }}>
                                {formatDateDDMMYYYYHHMMSS_UTC(rawDate)}
                            </p>
                        </div>
                    );
                }
            },

            {
                Header: 'Created By',
                accessor: 'created_by',
                disableSortBy: true,
                Cell: ({ row }) => {

                    return (
                        <div style={{ textAlign: 'left', color: '#222F3E', margin: 0 }} className="no-text-cursor">
                            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.created_by}</p>
                        </div>
                    );
                }
            },
            {
                Header: () => <p style={{ textAlign: 'left' }}>Schedule Type</p>,
                accessor: 'type',
                disableSortBy: true,
                Cell: ({ row }) => {
                    const createdDate = formatDateDDMMYYYY(row.original.created_at);
                    const dueDate = formatDateDDMMYYYY(row.original.due_date);
                    return (
                        <div className="no-text-cursor">
                            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}  >
                                {createdDate === dueDate ? 'Due Now' : 'Scheduled for Later'}
                            </p>
                        </div>
                    );
                }
            },
            {
                Header: () => <p style={{ textAlign: 'left' }}>Type</p>,
                accessor: 'course_mode',
                disableSortBy: true,
                Cell: ({ row }) => {
                    const isCourseMode = row.original.course_mode;

                    return (
                        <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }} className="no-text-cursor">
                            {isCourseMode}
                        </p>
                    );
                }
            },
            {
                Header: () => <p style={{ textAlign: 'left' }}>Status</p>,
                accessor: 'verified',
                disableSortBy: true,
                Cell: ({ row }) => {
                    return (
                        <span className="no-text-cursor"
                            style={{
                                color: row.original.verified ? "green" : "orange",
                                fontWeight: "500"
                            }}
                        >
                            {row.original.verified ? "Approved" : "Pending"}
                        </span>
                    );
                }
            },


            {
                Header: () => <p style={{ textAlign: 'right' }}><span style={{}}>Total Amount</span> </p>,
                accessor: 'total_amount_scheduled',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: 'right', color: '#222F3E', margin: 0 }} className="no-text-cursor">
                        <span style={{ marginRight: '25px' }}>₹ {row.original.total_amount_scheduled}</span>
                    </div>
                )
            },
            {
                Header: 'Action',
                Cell: ({ row }) => {

                    const { verified } = row.original;
                    const createdDate = formatDateDDMMYYYY(row.original.created_at);
                    const scheduledDate = formatDateDDMMYYYY(row.original.due_date);

                    const dueDate = new Date(row.original.due_date);
                    const today = new Date();
                    const isPastDue = dueDate < today; // true if due date already passed
                    const isUpcoming = dueDate >= today;
                    return (
                        <div style={{ display: 'flex', gap: '10px' }}>
                            {/* Print Icon */}
                            <div style={{ display: 'flex', gap: '20px' }}>

                                {!verified && (<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    width="24"
                                    height="24"
                                    fill="#7F56DA"
                                    style={{ cursor: 'pointer' }}
                                    // onClick={() => handelSendOtp(row)}
                                    onClick={(e) => {
                                        e.stopPropagation(); // prevent parent click
                                        handelSendOtp(row);
                                    }}

                                ><title>Send OTP</title>
                                    <path d="M458.5 112H265V62.4A31.4 31.4 0 0 0 233.6 31H62.4A31.4 31.4 0 0 0 31 62.4v387.2A31.4 31.4 0 0 0 62.4 481h171.2A31.4 31.4 0 0 0 265 449.6V292h193.5A22.5 22.5 0 0 0 481 269.5V134.5A22.5 22.5 0 0 0 458.5 112ZM125.5 50.1h45a11.3 11.3 0 0 1 0 22.5h-45a11.3 11.3 0 0 1 0-22.5Zm45 411.8h-45a11.3 11.3 0 1 1 0-22.5h45a11.3 11.3 0 0 1 0 22.5Zm74.7-41.6H50.8V91.8h194.4V112H125.3a22.3 22.3 0 0 0-22.3 22.3V269.7a22.3 22.3 0 0 0 22.3 22.3H166v36.1a11.1 11.1 0 0 0 19 7.9L229 292h16.2ZM220.8 210.2a11.3 11.3 0 0 1-11.3 19.5L195.3 221.4V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4L161.5 202l-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3ZM328.8 210.2a11.3 11.3 0 0 1-11.3 19.5l-14.3-8.3V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4l14.3-8.3-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3ZM436.8 210.2a11.3 11.3 0 0 1-11.3 19.5l-14.3-8.3V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4l14.3-8.3-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3Z" />
                                </svg>)}
                                {verified && (<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#7F56DA"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                        e.stopPropagation();   // prevent parent click
                                        handlePrintNotice(row);
                                    }}
                                    data-tooltip-id="admission-tip"
                                    data-tooltip-content="Print Notice"
                                >
                                    <path d="M6 9V2h12v7" />
                                    <path d="M6 18H4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2" />
                                    <rect x="6" y="14" width="12" height="8" />
                                    <title>Print Notice</title>
                                </svg>)}
                                {/* Reminder Icon (only if due date is past) */}
                                {verified && isUpcoming && (
                                    <div className='d-flex gap-3'>


                                        <svg
                                            fill="#7F56DA"
                                            viewBox="0 0 32.75 32.75"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="22"
                                            height="22"
                                            onClick={(e) => {
                                                e.stopPropagation(); // prevent parent click
                                                handleSendReminder(row);
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        ><title>Send Reminder</title>

                                            <g>
                                                <path d="M29.375,1.25h-1.123c0.029-0.093,0.059-0.186,0.059-0.289C28.311,0.43,27.879,0,27.348,0s-0.961,0.431-0.961,0.961 c0,0.103,0.028,0.196,0.059,0.289h-3.68c0.029-0.093,0.059-0.186,0.059-0.289C22.824,0.43,22.393,0,21.861,0 C21.332,0,20.9,0.431,20.9,0.961c0,0.103,0.029,0.196,0.06,0.289h-3.681c0.029-0.093,0.058-0.186,0.058-0.289 C17.337,0.43,16.907,0,16.376,0c-0.531,0-0.961,0.431-0.961,0.961c0,0.103,0.028,0.196,0.058,0.289h-3.681 c0.029-0.093,0.059-0.186,0.059-0.289C11.851,0.43,11.42,0,10.89,0c-0.531,0-0.962,0.431-0.962,0.961 c0,0.103,0.028,0.196,0.058,0.289h-3.68c0.03-0.093,0.059-0.186,0.059-0.289C6.365,0.43,5.935,0,5.404,0 C4.873,0,4.442,0.431,4.442,0.961c0,0.103,0.028,0.196,0.058,0.289H3.375c-1.518,0-2.75,1.233-2.75,2.75v26 c0,1.518,1.232,2.75,2.75,2.75H26.27l5.855-5.855V4C32.125,2.484,30.893,1.25,29.375,1.25z M30.625,26.273l-0.311,0.311h-2.355 c-1.102,0-2,0.9-2,2v2.355l-0.311,0.311H3.375c-0.689,0-1.25-0.561-1.25-1.25V5h28.5V26.273z"></path>
                                                <path d="M11.095,28.648h10.559c1.589,0,2.88-1.293,2.88-2.881V10.409c0-1.588-1.292-2.88-2.88-2.88H11.095 c-1.588,0-2.88,1.292-2.88,2.88v15.358C8.215,27.355,9.507,28.648,11.095,28.648z M16.595,27.688c-0.646,0-1.17-0.523-1.17-1.168 c0-0.646,0.524-1.17,1.17-1.17c0.645,0,1.168,0.523,1.168,1.17C17.764,27.164,17.24,27.688,16.595,27.688z M10.136,10.409 c0-0.529,0.43-0.96,0.959-0.96h10.559c0.529,0,0.959,0.431,0.959,0.96v13.438c0,0.529-0.43,0.961-0.959,0.961H11.095 c-0.53,0-0.959-0.432-0.959-0.961V10.409z"></path>
                                            </g>
                                        </svg>
                                        <svg
                                            fill="#7F56DA"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="22"
                                            height="22"
                                            onClick={(e) => {
                                                e.stopPropagation(); // prevent parent click
                                                handleSendNotice(row);
                                            }}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <title>Send Notice</title>
                                            <path d="M21.5 3H2.5C1.12 3 0 4.12 0 5.5v13C0 19.88 1.12 21 2.5 21h19c1.38 0 2.5-1.12 2.5-2.5v-13C24 4.12 22.88 3 21.5 3zM22 18.5c0 .28-.22.5-.5.5h-19a.5.5 0 0 1-.5-.5V5.5c0-.28.22-.5.5-.5h19c.28 0 .5.22.5.5v13z" />
                                            <path d="M3.64 5.95l8.36 6.01 8.36-6.01a.5.5 0 0 1 .59.81l-8.7 6.25a1.5 1.5 0 0 1-1.8 0l-8.7-6.25a.5.5 0 0 1 .59-.81z" />
                                            <path d="M4.5 17h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1zM4.5 15h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1z" />
                                        </svg>

                                    </div>
                                )}

                                {/* Penalty Raise Icon — only if due date is over */}
                                {verified && isPastDue && (
                                    <div className='d-flex gap-3'>
                                        <svg
                                            fill="#7F56DA"
                                            viewBox="0 0 32.75 32.75"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="22"
                                            height="22"
                                            onClick={(e) => {
                                                e.stopPropagation(); // prevent parent click
                                                handleSendReminder(row);
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        ><title>Send Additional Reminder For Penalty</title>

                                            <g>
                                                <path d="M29.375,1.25h-1.123c0.029-0.093,0.059-0.186,0.059-0.289C28.311,0.43,27.879,0,27.348,0s-0.961,0.431-0.961,0.961 c0,0.103,0.028,0.196,0.059,0.289h-3.68c0.029-0.093,0.059-0.186,0.059-0.289C22.824,0.43,22.393,0,21.861,0 C21.332,0,20.9,0.431,20.9,0.961c0,0.103,0.029,0.196,0.06,0.289h-3.681c0.029-0.093,0.058-0.186,0.058-0.289 C17.337,0.43,16.907,0,16.376,0c-0.531,0-0.961,0.431-0.961,0.961c0,0.103,0.028,0.196,0.058,0.289h-3.681 c0.029-0.093,0.059-0.186,0.059-0.289C11.851,0.43,11.42,0,10.89,0c-0.531,0-0.962,0.431-0.962,0.961 c0,0.103,0.028,0.196,0.058,0.289h-3.68c0.03-0.093,0.059-0.186,0.059-0.289C6.365,0.43,5.935,0,5.404,0 C4.873,0,4.442,0.431,4.442,0.961c0,0.103,0.028,0.196,0.058,0.289H3.375c-1.518,0-2.75,1.233-2.75,2.75v26 c0,1.518,1.232,2.75,2.75,2.75H26.27l5.855-5.855V4C32.125,2.484,30.893,1.25,29.375,1.25z M30.625,26.273l-0.311,0.311h-2.355 c-1.102,0-2,0.9-2,2v2.355l-0.311,0.311H3.375c-0.689,0-1.25-0.561-1.25-1.25V5h28.5V26.273z"></path>
                                                <path d="M11.095,28.648h10.559c1.589,0,2.88-1.293,2.88-2.881V10.409c0-1.588-1.292-2.88-2.88-2.88H11.095 c-1.588,0-2.88,1.292-2.88,2.88v15.358C8.215,27.355,9.507,28.648,11.095,28.648z M16.595,27.688c-0.646,0-1.17-0.523-1.17-1.168 c0-0.646,0.524-1.17,1.17-1.17c0.645,0,1.168,0.523,1.168,1.17C17.764,27.164,17.24,27.688,16.595,27.688z M10.136,10.409 c0-0.529,0.43-0.96,0.959-0.96h10.559c0.529,0,0.959,0.431,0.959,0.96v13.438c0,0.529-0.43,0.961-0.959,0.961H11.095 c-0.53,0-0.959-0.432-0.959-0.961V10.409z"></path>
                                            </g>
                                        </svg>
                                        {/* <svg
                                            width="25"
                                            height="25"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#FF4C4C"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            style={{ cursor: "pointer" }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleOpenPenalityGiveInFeeDue(row);
                                            }}
                                        >
                                            <title>Raise Penalty</title>
                                            <rect x="3" y="4" width="18" height="18" rx="3" />
                                            <line x1="3" y1="10" x2="21" y2="10" />
                                            <circle cx="18" cy="6" r="3" />
                                            <text x="18" y="7" fontSize="3" textAnchor="middle">%</text>
                                            <path d="M8 16 L12 12 L16 16" />
                                        </svg> */}


                                        {/* <svg
                                            viewBox="0 0 64 64"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="25"
                                            height="25"
                                            style={{ cursor: "pointer" }}
                                            stroke="#7F56DA"
                                            stroke-width="4"
                                            fill="none"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleOpenPenalityGiveInFeeDue(row);
                                            }}
                                        >
                                            <title>Raise Penalty</title>
                                            <path d="M55.5,31a23.93,23.93,0,0,1-.41,5.44,23.51,23.51,0,0,1-42.37,9" stroke-linecap="round" />
                                            <path d="M8.49,32.6a23.26,23.26,0,0,1,.42-5A23.51,23.51,0,0,1,51.2,18.43" stroke-linecap="round" />
                                            <polyline points="40.63 17.46 51.48 18.73 52.56 8.55" stroke-linecap="round" />
                                            <polyline points="23.08 46.19 12.24 44.92 11.15 55.1" stroke-linecap="round" />
                                            <path d="M25.79,22.57h2.92c2.85,0,6,.94,6,5.27,0,4.71-4,6.51-8.22,6a.25.25,0,0,0-.2.42l9,9.67" stroke-linecap="round" />
                                            <line x1="38.14" y1="22.57" x2="28.07" y2="22.57" stroke-linecap="round" />
                                            <line x1="25.94" y1="28" x2="38.21" y2="28" stroke-linecap="round" />
                                        </svg> */}





                                    </div>
                                )}





                            </div>
                        </div>
                    );
                }
            }

        ],
        []
    );



    const handleSetSearchResults = (data) => {
        if (Array.isArray(data)) {
            setFilterScheduledFee(data);
        } else if (Array.isArray(data)) {
            setFilterScheduledFee(data);
        } else {
            setFilterScheduledFee([]);
        }
    };


    const [showPrintNoticeModal, setShowPrintNoticeModal] = useState(false);
    const [selectedCourseStudents, setSelectedCourseStudents] = useState();

    const handlePrintNotice = (row) => {

        setSelectedCourseStudents(row.original);
        setShowPrintNoticeModal(true);
    }

    return (
        <>

            <>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100vh",
                    overflow: "hidden",
                    position: "relative",
                }}>
                    {isLoading ? (
                        <TableSkeleton />
                    ) : (
                        <>
                            {/* ── FIXED: Title + Add Schedule Button ── */}
                            <div style={{ flexShrink: 0, padding: "0 12px" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <h2 className="main-heading">Schedule Fee & Due ({totalCount})</h2>
                                    <button className="add-btn" onClick={() => navigate('/finance/add-fee-schedule')} style={{ padding: "10px 25px" }}>
                                        <span className="me-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
                                                fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                                <line x1="16" y1="2" x2="16" y2="6" />
                                                <line x1="8" y1="2" x2="8" y2="6" />
                                                <line x1="3" y1="10" x2="21" y2="10" />
                                                <line x1="12" y1="14" x2="12" y2="20" />
                                                <line x1="9" y1="17" x2="15" y2="17" />
                                            </svg>
                                        </span>
                                        Add Schedule
                                    </button>
                                </div>
                            </div>

                            {/* ── FIXED: Search + Filters ── */}
                            <div style={{ flexShrink: 0, padding: "8px 12px" }}>
                                <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", alignItems: "center" }}>
                                    <SearchingBar
                                        placeholder="Search by course...."
                                        url="finance/course-fee-schedule/"
                                        filterQueryString={filterQueryString}
                                        setResults={handleSetSearchResults}
                                        ref={searchInputRef}
                                        setTotalCount={setTotalCount}
                                        setFilterQueryString={setFilterQueryString}
                                        setSearchLoading={setSearchLoading}
                                        setCurrentPage={setCurrentPage}
                                    />
                                    <div style={{ width: "200px" }}>
                                        <Select
                                            options={courseOptions}
                                            value={selectedCourse}
                                            onChange={handleCourseChange}
                                            isClearable
                                            placeholder="Select Course"
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{
                                                ...reactSelectStyles,
                                                control: (base, state) => ({
                                                    ...reactSelectStyles.control?.(base, state),
                                                    minHeight: "34px",
                                                }),
                                            }}
                                        />
                                    </div>
                                    <div style={{ width: "200px" }}>
                                        <Select
                                            options={semesterOptions}
                                            value={selectedSemester}
                                            onChange={handleSemesterChange}
                                            isClearable
                                            placeholder="Select Semester"
                                            isDisabled={!selectedCourse}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{
                                                ...reactSelectStyles,
                                                control: (base, state) => ({
                                                    ...reactSelectStyles.control?.(base, state),
                                                    minHeight: "34px",
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* ── SCROLLABLE: Table only ── */}
                            <div style={{
                                flex: 1,
                                minHeight: 0,
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden",
                                padding: "0 12px",
                                position: "relative",
                            }}>
                                {filterLoading ? (
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1 }}>
                                        <SpinnerLoader />
                                    </div>
                                ) : formattedData?.length > 0 ? (
                                    <>
                                        <AdvanceTable
                                            columns={columns}
                                            handlePageChange={handlePageChange}
                                            pageCounts={pageCounts}
                                            selectedOrgDetails={selectedScheduledFee}
                                            data={formattedData}
                                            handleRowClick={handleRowClick}
                                            currentPage={currentPage}
                                            checkbox={false}
                                        />
                                        <TableLoaderOverlay isLoading={tableLoading} />
                                    </>
                                ) : (!isLoading && !isSearchLoading && (
                                    <div style={{
                                        display: "flex", flexDirection: "column",
                                        alignItems: "center", justifyContent: "center",
                                        flex: 1, color: "#888", textAlign: "center",
                                    }}>
                                        No Fee Scheduled available.
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>

                {/* ── MODALS (outside layout, no effect on scroll) ── */}
                {selectedCourseStudents?.course_mode?.toLowerCase()?.includes("individual") ? (
                    <FeeNoticeStudentsWise isOpen={showPrintNoticeModal} students={selectedCourseStudents} onClose={() => setShowPrintNoticeModal(false)} />
                ) : (
                    <FeeNoticeCourseWise isOpen={showPrintNoticeModal} students={selectedCourseStudents} onClose={() => setShowPrintNoticeModal(false)} />
                )}
                <OtpModal
                    title="Verify Fee Schedule & Due"
                    heading="Please Select person to send the approval message to the assigned person via WhatsApp."
                    isOpen={otpModalOpen}
                    onConfirm={() => console.log("test")}
                    onCancel={handleCancelOtp}
                    onResend={handlesResendOtpToAssignedPerson}
                    studentResponse={studentResponse}
                    employees={helpdeskperson}
                    hideOtpInput={true}
                    fromDiscountDashboard="No need to resend otp"
                />
                <WaitFeeApprovalsModal
                    isOpen={showWaittingModal}
                    onClose={() => setShowWaitingModal(false)}
                    onStatusChange={() => getFeeScheduledFee()}
                />
                <ConfirmationModal
                    isOpen={showReminderModal}
                    title="Send Reminder"
                    message={<>Are you sure you want to send a reminder for <b>{formatCourseListWithRoman(Array.from(selectedRow?.course_names || []))}</b>?</>}
                    onConfirm={confirmSendReminder}
                    onCancel={() => setShowReminderModal(false)}
                    setWidth="400px"
                    isSubmitting={isSubmitting}
                />
                <ConfirmationModal
                    isOpen={showNoticeModal}
                    title="Send Notice"
                    message={<>Are you sure you want to send a notice for <b>{formatCourseListWithRoman(Array.from(selectedRow?.course_names || []))}</b>?</>}
                    onConfirm={confirmSendNotice}
                    onCancel={() => setShowNoticeModal(false)}
                    setWidth="400px"
                    isSubmitting={isSubmitting}
                />
                <AddPenalityInFeeScheduledFee isOpen={showPenalityCreateModal} onClose={() => setShowPenalityCreateModal(false)} />
            </>



            <div>

                {selectedCourseStudents?.course_mode
                    ?.toLowerCase()
                    ?.includes("individual") ? (
                    <FeeNoticeStudentsWise
                        isOpen={showPrintNoticeModal}
                        students={selectedCourseStudents}
                        onClose={() => setShowPrintNoticeModal(false)}
                    />
                ) : (
                    <FeeNoticeCourseWise
                        isOpen={showPrintNoticeModal}
                        students={selectedCourseStudents}
                        onClose={() => setShowPrintNoticeModal(false)}
                    />
                )}


                <OtpModal
                    // key={otpModalKey}
                    title="Verify Fee Schedule & Due"
                    heading={`Please Select  person to send the approval message to the assigned person via WhatsApp.`}
                    isOpen={otpModalOpen}
                    // onConfirm={handleConfirmOtp}
                    onConfirm={() => console.log("test")}
                    onCancel={handleCancelOtp}
                    onResend={handlesResendOtpToAssignedPerson}
                    studentResponse={studentResponse}
                    employees={helpdeskperson}
                    hideOtpInput={true}
                    fromDiscountDashboard={"No need to resend otp"}
                />



                <WaitFeeApprovalsModal isOpen={showWaittingModal}
                    onClose={() => {
                        setShowWaitingModal(false)
                        // navigate(-1)
                    }}
                    onStatusChange={() => getFeeScheduledFee()} />


                <ConfirmationModal
                    isOpen={showReminderModal}
                    title="Send Reminder"
                    message={
                        <>
                            Are you sure you want to send a reminder for{" "}
                            <b>
                                {formatCourseListWithRoman(Array.from(selectedRow?.course_names || []))}
                            </b>
                            ?
                        </>
                    }
                    onConfirm={confirmSendReminder}
                    onCancel={() => setShowReminderModal(false)}
                    setWidth="400px"
                    isSubmitting={isSubmitting}
                />



                <ConfirmationModal
                    isOpen={showNoticeModal}
                    title="Send Notice"
                    message={
                        <>
                            Are you sure you want to send a reminder for{" "}
                            <b>
                                {formatCourseListWithRoman(Array.from(selectedRow?.course_names || []))}
                            </b>
                            ?
                        </>
                    }
                    onConfirm={confirmSendNotice}
                    onCancel={() => setShowNoticeModal(false)}
                    setWidth="400px"
                    isSubmitting={isSubmitting}
                />

                <AddPenalityInFeeScheduledFee isOpen={showPenalityCreateModal} onClose={() => setShowPenalityCreateModal(false)} />
            </div>
        </>
    );
};

